// @noflow
import {
    attemptCreateRecipe,
    attemptUpdateRecipe,
    cancelTemplate,
    getRecipes,
    showTemplateList
} from '~/core/state/recipes/actions';
import {
    getCurrentRecipe,
    getIsFirstLoadingDone,
    getModalVisiblePage,
    getRecipesList,
    getTemplatesList
} from '~/core/state/recipes/selectors';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as React from 'react';
import RecipesList from './component';
import { recipeStatus } from '~/core/constants/recipes';

class RecipesListContainer extends React.Component {
    static propTypes = {
        getRecipes: PropTypes.func.isRequired
    };

    componentDidMount() {
        const { getRecipes } = this.props;

        getRecipes();
    }

    render() {
        return <RecipesList {...this.props} />;
    }
}

const mapStateToProps = (state, { consumerId, producerId }) => {
    const currentRecipe = getCurrentRecipe(state);
    const readyToSave =
        !!currentRecipe && // 1st check if is there any recipe
        // then check it is not already being created or updated
        ![recipeStatus.CREATING, recipeStatus.UPDATING].includes(currentRecipe.get('status')) &&
        currentRecipe.getIn(['data', 'producer']) !== -1 && // then if is there a producer selected
        (currentRecipe.get('isNotification') === true
            ? // if notification then is there at least one notification type selected
              currentRecipe.getIn(['data', 'action', 'value']).includes(true)
            : currentRecipe.getIn(['data', 'consumer']) !== -1); // otherwise if is there a consumer selected
    return {
        canAddRecipe: getTemplatesList(state, { producerId, consumerId }).size > 0,
        consumerId,
        currentRecipe,
        isFirsLoadingDone: getIsFirstLoadingDone(state),
        modalVisiblePage: getModalVisiblePage(state),
        producerId,
        readyToSave,
        recipes: getRecipesList(state, { producerId, consumerId })
    };
};

const mapDispatchToProps = {
    attemptCreateRecipe,
    attemptUpdateRecipe,
    cancelTemplate,
    getRecipes,
    showTemplateList
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { attemptCreateRecipe, attemptUpdateRecipe } = dispatchProps;
    const { currentRecipe } = stateProps;

    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        saveRecipe: () =>
            currentRecipe.get('status') === recipeStatus.EDITING
                ? attemptUpdateRecipe(currentRecipe)
                : attemptCreateRecipe({ newRecipe: currentRecipe })
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(RecipesListContainer);



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/recipes-list/index.js